
























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { preferred_language, languages } from "@/config/languags.config.json";

import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import StandartModal from "@/components/app/standart-modal.vue";
import BSwitch from "@/components/app/switchs/b-switch.vue";

const flags = require.context(
  "@/assets/img/flags",
  false,
  /^\.\/[a-z]{2,3}\.png$/
);
const flagLocales = flags.keys().map((key) => key.slice(2, -4));

@Component({
  components: { StandartModal, SubmitResetButtonGroop, BSwitch },
})
export default class SettingLanguages extends Vue {
  @Prop({ type: Array, default: () => [] }) lans_config!: Array<string>;

  locales = [preferred_language];
  suportedLocales = [
    ...languages,
    ...flagLocales.filter((l) => !languages.includes(l)),
  ];

  newLang = "";
  addError: string | null = null;

  get addState(): boolean | null {
    return this.addError === null ? null : false;
  }

  getFlag(lang: string): string | null {
    return this.$getImage(`${lang}.png`, "flags");
  }

  change(l: string): void {
    const i = this.locales.findIndex((lang) => lang == l);
    if (i < 0) this.locales.push(l);
    else this.locales.splice(i, 1);
  }

  addLanguage(): void {
    const lang = this.newLang.toLowerCase();
    if (!/^[a-z]{2,3}$/.test(lang)) {
      this.addError = String(this.$t("Settings.languages.form.add.invalid"));
      return;
    }
    if (this.suportedLocales.includes(lang)) {
      this.addError = String(this.$t("Settings.languages.form.add.exists"));
      return;
    }
    this.addError = null;
    this.newLang = "";
    this.suportedLocales.push(lang);
    if (!this.locales.includes(lang)) this.locales.push(lang);
  }

  @Watch("lans_config", { deep: true })
  cteatedLocales(): void {
    this.locales = this.lans_config.length
      ? [...this.lans_config]
      : [preferred_language];
    this.mergeSuportedLocales();
  }

  mergeSuportedLocales(): void {
    this.locales.forEach((lang) => {
      if (!this.suportedLocales.includes(lang)) this.suportedLocales.push(lang);
    });
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    this.$emit("updateConfig", { languages: this.locales });
    this.$bvModal.hide("root-setting-languages");
  }

  onReset(): void {
    this.newLang = "";
    this.addError = null;
    this.cteatedLocales();
  }

  mounted(): void {
    this.cteatedLocales();
  }
}
